<template>
    <div class="nevs-content">
        <div v-if="warePopup.show" class="nevs-popup-container">
            <div class="nevs-popup">
                <div class="nevs-popup-text">
                    <NevsTextField v-model="warePopup.data.code"
                                   :label="$LANG.Get('fields.code') + ':'"></NevsTextField>
                    <NevsTextField v-model="warePopup.data.name" :error="warePopup.validation.name"
                                   :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
                    <NevsSelect :readonly="warePopup.data.id !== 0" v-model="warePopup.data.measurement_unit_id" :ajax="'select/measurement-units'"
                                :label="$LANG.Get('fields.measurementUnit')"></NevsSelect>
                    <div v-if="warePopup.data.id === 0" class="measurement-unit-disclaimer">{{ $LANG.Get('labels.storeMeasurementUnitsDisclaimer') }}</div>
                </div>
                <div class="nevs-popup-buttons">
                    <NevsButton class="error" @click="warePopup.cancel()">{{
                            $LANG.Get('buttons.cancel')
                        }}
                    </NevsButton>
                    <NevsButton class="success" @click="warePopup.save()">{{ $LANG.Get('buttons.ok') }}</NevsButton>
                </div>
            </div>
        </div>
        <NevsCard class="help-wares">
            <NevsTextField :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="waresData.filters.name"></NevsTextField>
            <span style="float: right;"><NevsButton class="primary" @click="addWare">{{ $LANG.Get('buttons.addWare') }}</NevsButton></span>
            <div style="clear: both;"></div>

            <NevsTinyGrid :columns="gridColumns" :records="waresData.records" :actions="gridActions"
                          @action="gridAction"></NevsTinyGrid>
        </NevsCard>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTinyGrid from "@/components/nevs/NevsTinyGrid.vue";

export default {
    name: "ModuleWares",
    components: {NevsTinyGrid, NevsSelect, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            waresData: {
                filters: {
                    name: ''
                },
                records: [],
                filterTimer: null
            },
            warePopup: {
                show: false,
                data: {
                    id: 0,
                    code: '',
                    name: '',
                    measurement_unit_id: 2,
                },
                validation: {
                    name: ''
                },
                reset: () => {
                    this.warePopup.data = {
                        id: 0,
                        name: '',
                        measurement_unit_id: 2,
                    };
                    this.warePopup.validation = {
                        name: ''
                    }
                },
                cancel: () => {
                    this.warePopup.show = false;
                },
                save: () => {
                    let success = true;
                    if (this.warePopup.data.name === '') {
                        success = false;
                        this.warePopup.validation.name = this.$LANG.Get('labels.mandatoryField');
                    } else {
                        this.warePopup.validation.name = '';
                    }
                    if (success) {
                        let method = (this.warePopup.data.id === 0) ? 'post' : 'put';
                        let action = (this.warePopup.data.id === 0) ? 'wares' : 'wares/' + this.warePopup.data.id;
                        let vm = this;
                        this.$API.APICall(method, action, this.warePopup.data, (data, success) => {
                            vm.warePopup.show = false;
                            vm.warePopup.reset();
                            if (success) {
                                vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                                vm.reloadWares();
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            }
        }
    },
    computed: {
        gridColumns() {
            return [
                {key: 'name', label: this.$LANG.Get('fields.name')}
            ];
        },
        gridActions() {
            return [
                {name: 'edit', icon: 'fa-solid fa-pen', tooltip: this.$LANG.Get('tooltips.editWare')},
                {name: 'delete', icon: 'fa-solid fa-trash', tooltip: this.$LANG.Get('tooltips.deleteWare')}
            ];
        }
    },
    watch: {
        'waresData.filters.name': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadWares();
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        gridAction(name, ware) {
            if (name === 'edit') {
                this.editWare(ware);
            } else if (name === 'delete') {
                this.deleteWare(ware);
            }
        },
        editWare(ware) {
            let vm = this;
            this.$API.APICall('get', 'wares/' + ware.id, {}, (data, success) => {
                if (success && data.ware !== null) {
                    vm.warePopup.reset();
                    vm.warePopup.data = JSON.parse(JSON.stringify(data.ware));
                    vm.warePopup.show = true;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        addWare() {
            this.warePopup.reset();
            this.warePopup.show = true;
        },
        deleteWare(ware) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.wareRemovalQuestion'), callback: (response) => {
                    if (response) {
                        this.$API.APICall('delete', 'wares/' + ware.id, {}, (data, success) => {
                            if (success) {
                                vm.reloadWares();
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        reloadWares() {
            let vm = this;
            let request = {
                sort: {
                    field: 'name',
                    descending: false
                },
                filters: this.waresData.filters,
                currentPage: 1,
                rowsPerPage: 0
            };
            this.$API.APICall('get', 'wares', request, (data, success) => {
                if (success) {
                    vm.waresReady = true;
                    vm.waresData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        if (!this.$store.state.user.client.plus) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-wares',
                html: this.$LANG.Get('help.wares'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'wares');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.wares'),
                link: null
            }
        ]);
        this.reloadWares();
    }
}
</script>

<style scoped>

.measurement-unit-disclaimer {
    margin-left: 7px;
    font-weight: bold;
    font-size: 16px;
}


</style>